export default "__VITE_ASSET___Oq0gof___"